module.exports = require('frontend-analytics/meli-ga');
